export default {
      id: "SW-usage",
      viewBox: "0 0 160 160",
      url: __webpack_public_path__ + "svgsprite.svg#SW",
      toString: function () {
        return this.url;
      }
    }